import { Ship } from './ship.model';

export const shipMock = new Ship({
  activeStatus: 'TRUE',
  brand: '2',
  code: 'AL',
  name: 'ALLURE OF THE SEAS',
  shipClass: 'AL',
  medicalEnabled: true,
  safetyEnabled: true,
  healthCheckEnabled: true,
});

export const celebrityShipMock = new Ship({
  activeStatus: 'TRUE',
  brand: '2',
  code: 'CL',
  name: 'Celebrity Ship',
  shipClass: 'CL',
  medicalEnabled: true,
  safetyEnabled: true,
  healthCheckEnabled: true,
});

export const azamaraShipMock = new Ship({
  activeStatus: 'TRUE',
  brand: '2',
  code: 'AZ',
  name: 'Azamara Ship',
  shipClass: 'AZ',
  medicalEnabled: true,
  safetyEnabled: true,
  healthCheckEnabled: true,
});
